<template>
  <div class="video-section">
    <div class="container">
      <h2 class="section-title">社区医养服务中心全景视频</h2>
      <p class="section-desc">通过视频了解我们的产品和服务</p>

      <div
        class="video-container"
        @click="playVideo"
        :class="{ playing: isPlaying }"
      >
        <!-- 视频封面 -->
        <div class="video-cover" v-show="!isPlaying">
          <!-- 封面图片 - 您可以替换为实际的封面图片 -->
          <img :src="videoCover" alt="视频封面" v-if="videoCover" />
          <div class="cover-placeholder" v-else>
            <i class="el-icon-picture"></i>
            <span>视频封面图片</span>
          </div>

          <!-- 播放按钮 -->
          <div class="play-button">
            <i class="el-icon-video-play"></i>
          </div>
        </div>

        <!-- 视频播放器 -->
        <video
          ref="videoPlayer"
          controls
          v-show="isPlaying"
          :poster="videoCover"
          @ended="videoEnded"
        >
          <source :src="videoSrc" type="video/mp4" />
          您的浏览器不支持HTML5视频
        </video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoWithCover",
  props: {
    videoSrc: {
      type: String,
      required: true,
    },
    videoCover: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  methods: {
    playVideo() {
      if (!this.isPlaying) {
        this.isPlaying = true;
        this.$nextTick(() => {
          this.$refs.videoPlayer.play();
        });
      }
    },
    videoEnded() {
      this.isPlaying = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 主题色 */
$primary-color: #f97d01;

.video-section {
  padding: 80px 0;
  background: #f9f9f9;

  .section-title {
    font-size: 32px;
    color: #333;
    text-align: center;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .section-desc {
    font-size: 16px;
    color: #666;
    text-align: center;
    margin-bottom: 50px;
  }
}

.video-container {
  max-width: 800px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  position: relative;
  cursor: pointer;
  transition: all 0.5s ease;

  &:hover:not(.playing) {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);

    .play-button {
      transform: scale(1.1);
      background: rgba($primary-color, 0.9);
    }
  }

  video {
    width: 100%;
    display: block;
  }
}

.video-cover {
  position: relative;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 比例 */

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .cover-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #eee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;

    i {
      font-size: 60px;
      margin-bottom: 15px;
    }
  }
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba($primary-color, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  i {
    color: white;
    font-size: 40px;
    margin-left: 5px;
  }

  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    border-radius: 50%;
    animation: pulse 2s infinite;
  }
}

/* 脉冲动画 */
@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .video-section {
    padding: 50px 0;
  }

  .section-title {
    font-size: 26px !important;
  }

  .play-button {
    width: 60px;
    height: 60px;

    i {
      font-size: 30px;
    }
  }
}
</style>
